/**
 * Asset: Multi-store config
 * ------------------------------------------------------------------------------
 * Configuration file used in `redirect.js` and `currency.js` handler.
 * - All properties are required, leave empty string if unused.
 */
window.Frame = window.Frame || {};
window.Frame.MultiStore = [
  {
    storeCode: 'GB',
    storeName: 'United Kingdom',
    storeUrl: 'https://newbiestore.com/',
    supportedLanguages: 'EN',
    supportedCurrencies: 'GBP',
    supportedStores: 'GB',
  },
  {
    storeCode: 'EU',
    storeName: 'Europe',
    storeUrl: 'https://newbie.com/',
    supportedLanguages: 'EN',
    supportedCurrencies: 'EUR',
    supportedStores: 'AT,BE,CH,CY,CZ,FR,JP,LT,LV,LU,NL,PT,SK,DE,IT,IE,RO,SI,GR,HR,HU',
  },
  {
    storeCode: 'FI',
    storeName: 'Newbie Kappahl Store',
    storeUrl: 'https://kappahl.com/fi-FI/newbie-start/',
    supportedLanguages: 'FI',
    supportedCurrencies: 'EUR',
    supportedStores: 'FI',
    isExternal: true,
  },
  {
    storeCode: 'NO',
    storeName: 'Newbie Kappahl Store',
    storeUrl: 'https://kappahl.com/nn-NO/newbie-start/',
    supportedLanguages: 'NN',
    supportedCurrencies: 'NOK',
    supportedStores: 'NO',
    isExternal: true,
  },
  {
    storeCode: 'SE',
    storeName: 'Newbie Kappahl Store',
    storeUrl: 'https://kappahl.com/sv-SE/newbie-start/',
    supportedLanguages: 'SV',
    supportedCurrencies: 'SEK',
    supportedStores: 'SE',
    isExternal: true,
  },
  {
    storeCode: 'PL',
    storeName: 'Newbie Kappahl Store',
    storeUrl: 'https://kappahl.com/pl-PL/newbie-start/',
    supportedLanguages: 'PL',
    supportedCurrencies: 'PZL',
    supportedStores: 'PL',
    isExternal: true,
  },
];
